import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/pages/ListeEntreprises.vue"),
  },
  {
    path: "/:slug/",
    name: "liste-entreprises",
    component: () => import("@/pages/ListeEntreprises.vue"),
  },
  {
    path: "/entreprise/:slug",
    name: "entreprise",
    component: () => import("@/pages/Entreprise.vue"),
  },
  // {
  //   path: "*",
  //   name: "home",
  // },
];

export default new VueRouter({
  // mode: "history",
  routes,
});
